// NPM MODULES
import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  January: (
    <FormattedMessage id="ReportsIndex.January" defaultMessage="January" />
  ),
  February: (
    <FormattedMessage id="ReportsIndex.February" defaultMessage="February" />
  ),
  March: <FormattedMessage id="ReportsIndex.March" defaultMessage="March" />,
  April: <FormattedMessage id="ReportsIndex.April" defaultMessage="April" />,
  May: <FormattedMessage id="ReportsIndex.May" defaultMessage="May" />,
  June: <FormattedMessage id="ReportsIndex.June" defaultMessage="June" />,
  July: <FormattedMessage id="ReportsIndex.July" defaultMessage="July" />,
  August: <FormattedMessage id="ReportsIndex.August" defaultMessage="August" />,
  September: (
    <FormattedMessage id="ReportsIndex.September" defaultMessage="September" />
  ),
  October: (
    <FormattedMessage id="ReportsIndex.October" defaultMessage="October" />
  ),
  November: (
    <FormattedMessage id="ReportsIndex.November" defaultMessage="November" />
  ),
  December: (
    <FormattedMessage id="ReportsIndex.December" defaultMessage="December" />
  ),
};

export default FormattedMessages;
